import { useEffect, type ReactNode } from 'react'

interface ModalProps {
  open: boolean
  onClose: () => void
  title: string
  children: ReactNode
  widthClass?: string
}

export function Modal({ open, onClose, title, children, widthClass = 'max-w-md' }: ModalProps) {
  useEffect(() => {
    if (!open) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [open, onClose])

  if (!open) return null

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
      className="fixed inset-0 z-50 flex items-center justify-center bg-void/80 p-4"
      onClick={onClose}
    >
      <div
        className={`dropdown-enter max-h-[90vh] w-full ${widthClass} overflow-y-auto border border-hairline bg-panel`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="hairline-b flex items-center justify-between px-6 py-4">
          <h2 id="modal-title" className="tracked-caps text-sm text-ink">
            {title}
          </h2>
          <button
            type="button"
            onClick={onClose}
            aria-label="Schließen"
            className="text-sm text-muted transition-colors hover:text-bernstein"
          >
            ✕
          </button>
        </div>
        <div className="px-6 py-5">{children}</div>
      </div>
    </div>
  )
}
